class CartRecommendations extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this)
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return
    observer.unobserve(this)

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div')
        html.innerHTML = text
        const recommendations = html.querySelector('cart-recommendations')
        // Doublons avec le bloc Shop the look de la page (voir global.js) et plafond `data-limit`.
        if (recommendations && typeof applyRecommendationExclusions === 'function') {
          applyRecommendationExclusions(recommendations)
        }
        // Sans produit recommandé, la réponse ne contient que le titre et une liste vide :
        // on retire le bloc plutôt que de laisser le placeholder de chargement affiché.
        if (recommendations && recommendations.querySelector('li')) {
          this.innerHTML = recommendations.innerHTML
        } else {
          this.remove()
        }
      })
      .catch((e) => {
        console.error(e)
        this.remove()
      })
  }
}
customElements.define('cart-recommendations', CartRecommendations)
